// Port of api/fuel/app/classes/controller/api/monty/buddies/verify.php
import F from 'offline/filter/constants'
import { runOwnerEndpoint } from 'offline/api/monty'

export default function(params) {
	if (!params.slug && params.name) params = Object.assign({}, params, { slug: params.name })
	return runOwnerEndpoint(params, F.OWNER_BUDDIES, { permissions: false })
}
